import { RECEIVE_PARTNERS_LINK } from './types';

const initialState = {};
const reducerPartnersLink = (state = initialState, action) => {
	let newState = { ...state };
	switch (action.type) {
		case RECEIVE_PARTNERS_LINK:
			if (action.prefix) {
				newState[action.prefix] = action.data;
			}
			return newState;

		default:
			return newState;
	}
};

export default reducerPartnersLink;
